export default function () {
  const widgetName = 'joinTodayWidgetFeature';
  const widgetOpts = joinTodayWidgetFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,





    cardWidgetLoaded: function () {
      function removeAtt() {
        const wrapperIcon = `
        <div class="wrapper-icon"></div>
        `
        const wrapperIconMobile = `
        <div class="wrapper-icon-mobile"></div>
        `

        $(".moreButton").attr("target", "");
        $(".moreButton").attr("class", "button");

        $("")
        $(`#${widgetName} .card-widget-item `).each(function () {
          $(this).find('.card-widget-title, .card-widget-description').wrapAll(`<div class="wraper-text"><div class="wraper-join"><div class="wraper-text"></div></div></div>`)
        })
        $(wrapperIcon).prependTo(".wraper-join")
        $(wrapperIconMobile).appendTo(`#${widgetName} .card-widget-item .card-content`)
      }
      removeAtt()
    },

    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: true,
      text: 'click to join here'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}